export const AUTO_IMPORT_LOGS = {
    All: -1,
    Competition: 2,
    Match: 3,
    Team: 4,
    Player: 5,
    "Team Update": 6,
    "Player Update": 7,
    "Tournament Team": 8,
    "ICC Ranking": 9,
    "Competition Statistics": 10,
    "Competition Update": 11,
    "Inning Data Update": 12
}

export const AUTO_IMPORT_STATUS = {
    All: -1,
    Pending: 1,
    Started: 2,
    Ended: 3,
    Failed: 4
}